<template>
  <div class="quick-filter">
    <div class="title">{{ meta.label }}: </div>
    <!-- {{ value }} -->
    <template v-if="short">
      <div class="options">
        <div
          v-for="o in options"
          :key="o.id"
          class="option"
          :class="{active: value && value[0].value===o.id}"
          @click="()=>toggleOption(o)"
        >
          {{ o.label }}
        </div>
      </div>
    </template>
    <template v-else>
      <!-- {{ selectOption }} -->
      <select-comp-wrapper
        v-model="selectOption"
        :options="options"
        :multiple="false"
        :can-bold="false"
        :can-chart="false"
        :unsortable="true"
      />
    </template>
  </div>
</template>

<script>
import { getOptionAsValue } from '@/utils/dataUtils'
import SelectCompWrapper from './SelectCompWrapper.vue'
export default {
  components: { SelectCompWrapper },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: { required: true },
    options: { required: true },
    meta: { type: Object },
    shortThreshold: { default: 5 },
    // prefixLabel: String,
  },
  computed: {
    short() {
      return false //this.options.length < this.shortThreshold
    },
    selectOption: {
      get() {
        return this.value
      },
      set(o) {
        this.$emit('change', [getOptionAsValue(this.options.find(oo => oo.id === o[0].value))])
      },
    },
  },
  methods: {
    toggleOption(o) {
      this.$emit('change', [getOptionAsValue(o)])
    },
  },
}
</script>

<style lang="stylus" scoped>
.quick-filter
  &:not(:last-child)
    margin-right: vw(40px)

  .title
    // m-first-letter-case()
    m-font-size(12, 16)
    margin-bottom: vw(5px)
    height: vw(16px)
    color: $grey

  .options
    display: flex
    align-items: center

  .option
    m-font-size(10, 16)
    padding: vw(6px) vw(12px)
    border: 1px solid transparent
    border-radius: 1px
    color: $seat-orange
    cursor: pointer

    &:not(:last-child)
      margin-right: vw(10px)

    &:hover
      &:not(.active)
        border-color: #88e

    &.active
      background-color: #88e
      cursor: default
</style>
